import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';
import { useLocation, useNavigate } from 'react-router-dom';

import HorizontalMenuWrap from '@/components/HorizontalMenuWrap';
import { appRoutes } from '@/router/routes';
import { Role } from '@/types/roles';

interface MenuItem {
    name: string;
    component?: React.ReactNode;
    path: string;
    key: string;
}

const TicketMenu = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const queryClient = useQueryClient();
    const { roleLevel }: any = queryClient.getQueryData('me');
    const isPartTimeStaff = roleLevel === Role.PART_TIME_STAFF;

    const menuItems: MenuItem[] = [
        {
            name: t('ticket:TAB_TEMPLATE_MANAGEMENT'),
            path: `/${appRoutes.APP_MANAGEMENT.TICKET.ROOT}`,
            key: 'template-management',
        },
        {
            name: t('ticket:TAB_TICKET_USAGE'),
            path: `/${appRoutes.APP_MANAGEMENT.USE_TICKET.USE}`,
            key: 'ticket-usage',
        },
        ...(isPartTimeStaff
            ? []
            : [
                {
                    name: t('ticket:TAB_USAGE_HISTORY'),
                    path: `/${appRoutes.APP_MANAGEMENT.USE_TICKET.HISTORY}`,
                    key: 'usage-history',
                },
                {
                    name: t('ticket:TAB_ISSUE_HISTORY'),
                    path: `/${appRoutes.APP_MANAGEMENT.ISSUED_TICKET}`,
                    key: 'issue-history',
                },
            ]),
    ];

    const getActiveTabFromPath = () => {
        const currentPath = location.pathname;
        const item = menuItems.find((item) => currentPath === item.path);
        return item ? item.key : menuItems[0].key;
    };

    const [activeItem, setActiveItem] = useState<string>(getActiveTabFromPath());

    useEffect(() => {
        setActiveItem(getActiveTabFromPath());
    }, [location.pathname]);

    const onHandleActiveItem = (key: string) => {
        setActiveItem(key);
        const item = menuItems.find((item) => item.key === key);
        if (item) {
            navigate(item.path);
        }
    };

    return (
        <HorizontalMenuWrap
            menuItems={menuItems}
            activeItem={activeItem}
            onHandleActiveItem={onHandleActiveItem}
        />
    );
};

export default TicketMenu;
